class BundlePicker extends HTMLElement {
	constructor() {
		super()
		this.selectedVariantIds = new Map()
		this.variantPickers = this.querySelectorAll('.variant-picker')
		this.colorPickers = this.querySelectorAll('.colour-picker__custom')
		this.bundlePropertiesInput = document.getElementById('bundle-products-properties')
		this.addToCartButton = document.querySelector('.buy-buttons.product-atc__btn button[type="submit"]')

		this.variantPickers.forEach((picker) => {
			this.initVariantPicker(picker)
		})

		this.colorPickers.forEach((picker) => {
			this.initColorPicker(picker)
		})

		this.updateBundleProperties()
	}

	initVariantPicker(picker) {
		const handle = picker.dataset.handle
		const initialVariant = JSON.parse(picker.querySelector('[data-variant]').textContent)
		const errorMessage = picker.querySelector('.bundle-picker__variant-warning')

		const optionFields = picker.querySelectorAll('fieldset')
		let hasMultipleOptions = false
		optionFields.forEach((fieldset) => {
			const inputs = fieldset.querySelectorAll('input[type="radio"], input[type="checkbox"]')
			if (inputs.length > 1) {
				hasMultipleOptions = true
				errorMessage.classList.add('visible')
				inputs.forEach((input) => (input.checked = false))
			}
		})

		// If multiple options, do not set selectedVariantIds until user selects
		if (!hasMultipleOptions && initialVariant) {
			this.selectedVariantIds.set(handle, initialVariant.id)
		}

		picker.addEventListener('change', () => this.onVariantChange(picker, handle))
	}

	initColorPicker(picker) {
		const handle = picker.dataset.handle
		const swatches = picker.querySelectorAll('.custom-product-swatch')
		const errorMessage = picker.querySelector('.bundle-picker__variant-warning')
		
		swatches.forEach((swatch) => {
			if (swatch.classList.contains('active')) {
				const initialVariantId = swatch.dataset.variantId
				this.selectedVariantIds.set(handle, initialVariantId)
			} else {
				errorMessage.classList.add('visible')
			}

			swatch.addEventListener('click', () => this.onColorChange(picker, swatch, handle))
		})
	}

	onVariantChange(picker, handle) {
		const selectedInput = picker.querySelector('fieldset input:checked')
		const errorMessage = picker.querySelector('.bundle-picker__variant-warning')

		if (!selectedInput) return

		const selectedVariantId = selectedInput.dataset.variantId

		if (!selectedVariantId) return

		errorMessage.classList.remove('visible')
		// update the selected variant ID for the handle
		this.selectedVariantIds.set(handle, selectedVariantId)
		this.updateBundleProperties()
	}

	onColorChange(picker, swatch, handle) {
		const selectedVariantId = swatch.dataset.variantId
		const errorMessage = picker.querySelector('.bundle-picker__variant-warning')

		picker
			.querySelectorAll('.custom-product-swatch')
			.forEach((s) => {
				s.classList.remove('active')
				s.querySelector('input[type="radio"]').checked = false
			})
		swatch.classList.add('active')
		swatch.querySelector('input[type="radio"]').checked = true

		errorMessage.classList.remove('visible')

		this.selectedVariantIds.set(handle, selectedVariantId)
		this.updateBundleProperties()
	}

	updateBundleProperties() {
		const bundleProducts = Array.from(this.selectedVariantIds.values()).join(',')
		this.bundlePropertiesInput.value = bundleProducts

		this.validateBundleSelection()
	}

	disableAddToCartButton() {
		if (this.addToCartButton) {
			this.addToCartButton.disabled = true
			this.addToCartButton.classList.add('disabled')
			this.addToCartButton.textContent = 'Please select all options'
		}
	}

	enableAddToCartButton() {
		if (this.addToCartButton) {
			this.addToCartButton.disabled = false
			this.addToCartButton.classList.remove('disabled')
			this.addToCartButton.textContent = 'Add to Cart'
		}
	}

	validateBundleSelection() {
		// check if all variant pickers and all color pickers have a selected variant
		const allSelected = Array.from(this.variantPickers).every((picker) => {
			const selectedInput = picker.querySelector('fieldset input:checked')
			return selectedInput && selectedInput.dataset.variantId
		}) && 
		Array.from(this.colorPickers).every((picker) => {
			const activeSwatch = picker.querySelector('.custom-product-swatch.active')
			return activeSwatch && activeSwatch.dataset.variantId
		})

		if (allSelected) {
			this.enableAddToCartButton()
		} else {
			this.disableAddToCartButton()
		}


	}
}

if (!window.customElements.get('bundle-picker')) {
	window.customElements.define('bundle-picker', BundlePicker)
}
